(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/bottom-sheet-intersect/assets/javascripts/bottom-sheet-intersersect.js') >= 0) return;  svs.modules.push('/components/lb-ui/bottom-sheet-intersect/assets/javascripts/bottom-sheet-intersersect.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const INTERSECTION_SENSITIVITY = 0.1;

const BottomSheetIntersersect = _ref => {
  let children = _ref.children,
    intersectId = _ref.intersectId;
  if (!intersectId) {
    throw new Error('intersectId is mandatory');
  }
  const observer = useRef(null);
  const lastScrollTopPosition = useRef(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isIntersecting = _useState2[0],
    setIsIntersecting = _useState2[1];
  useEffect(() => () => {
    if (observer.current) {
      observer.current.disconnect();
      if (document.querySelector('body')) {
        document.querySelector('body').style.overflow = 'auto';
      }
    }
  }, []);
  useEffect(() => {
    if ('IntersectionObserver' in window) {
      if (document.querySelector('body')) {
        document.querySelector('body').style.overflow = 'hidden';
      }
      observer.current = new IntersectionObserver(entries => {
        entries.forEach(_ref2 => {
          let boundingClientRect = _ref2.boundingClientRect,
            intersectionRatio = _ref2.intersectionRatio;
          const scrollingDown = lastScrollTopPosition.current > boundingClientRect.top;
          if (lastScrollTopPosition.current === null || scrollingDown) {
            const isIntersectingValue = intersectionRatio > INTERSECTION_SENSITIVITY;
            if (isIntersectingValue !== isIntersecting) {
              setIsIntersecting(isIntersectingValue);
            }
          } else {
            setIsIntersecting(false);
          }
          lastScrollTopPosition.current = boundingClientRect.top;
        });
      }, {
        threshold: [0, 0.2]
      });
      observer.current.observe(document.getElementById(intersectId));
    }
  }, []);
  return React.createElement(svs.ui.ReactBottomSheet.BottomSheet, {
    behavior: "standard",
    className: "qa-bottom-sheet-intersect-".concat(isIntersecting ? 'hidden' : 'visible'),
    customer: "sport",
    isFixed: true,
    isVisible: !isIntersecting,
    transparent: false
  }, React.createElement(svs.ui.ReactBottomSheet.BottomSheetFooter, null, children));
};
setGlobal('svs.components.lbUi.bottomSheetIntersect.BottomSheetIntersersect', BottomSheetIntersersect);

 })(window);